export const isStringOnlyThaiAlpha = (original_text) => {
    return !(/[^ก-์]/.test(original_text))
}
export const isStringContainThaiAlpha = (original_text) => {
    return /[ก-์]/.test(original_text)
}
export const removeThaiAlpha = (original_text) => {
    return original_text.replace(/[ก-์]/, '')
}